export default "__VITE_ASSET__Zih$qDGN__"